import { store } from '@/store'
import _isEqual from 'lodash/isEqual'
import { ModuleName } from '@/store/modules/createWarehouseReceivingOrder'
import { machine } from '@/models/createWarehouseReceivingOrder/create-order-machine'
import { isValidMultiSkuHelper, isValidSingleSkuHelper } from '@/components/createWarehouseReceivingOrder/steps/addShippingConfigurations/helper'

export const clearShippingConfigurationValues = () => store.dispatch(ModuleName + '/clearShippingConfigurationValues')
export const validateShippingConfigurationValues = () => {
  const isShipBobLabels = store.getters[ModuleName + '/isShipbobLabels']
  const wroLabelPurchaseFlag = store.getters['enableWroLabelPurchaseFeatureFlag']
  const shippingConfigurations = store.getters[ModuleName + '/shippingConfigurations']
  if (isValidSingleSkuHelper(shippingConfigurations, (isShipBobLabels && wroLabelPurchaseFlag))) machine.transition('ALL_QUANTITIES_ADDED')
}

export const decidePath = () => {
  const isfloorLoadedContainerWithNoMultipleLots = store.getters[ModuleName + '/floorLoadedContainerWithNoMultipleLots']

  switch (store.getters[ModuleName + '/selectedSKUType'].id) {
    case 1:
      isfloorLoadedContainerWithNoMultipleLots ? machine.transition('IS_SINGLE_SKU_AUTO_FILL') : machine.transition('IS_SINGLE_SKU')
      break
    case 2:
      isfloorLoadedContainerWithNoMultipleLots ? machine.transition('IS_MULTI_SKU_AUTO_FILL') : machine.transition('IS_MULTI_SKU')
      break
    default:
      machine.transition('IS_SINGLE_SKU')
      break
  }
}

export const clearMultiSkuShippingConfigurationValues = () => store.dispatch(ModuleName + '/clearMultiSkuShippingConfigurationValues')

export const validateMultiSkuShippingConfigurations = () => {
  const isShipBobLabels = store.getters[ModuleName + '/isShipbobLabels']
  const wroLabelPurchaseFlag = store.getters['enableWroLabelPurchaseFeatureFlag']
  const boxConfigurations = store.getters[ModuleName + '/multiSkuShippingConfigurations']
  const selectedProducts = store.getters[ModuleName + '/selectedProductsWithLotInformation']
  if (isValidMultiSkuHelper({ selectedProducts, boxConfigurations }, (isShipBobLabels && wroLabelPurchaseFlag))) machine.transition('ALL_QUANTITIES_ADDED')
}

export const autoFillSingleSKUFloorLoadedContainer = () => {
  store.dispatch(ModuleName + '/autoFillSingleSKUFloorLoadedContainer')
  machine.transition('ALL_QUANTITIES_ADDED')
}
export const autoFillMultiSKUFloorLoadedContainer = () => {
  store.dispatch(ModuleName + '/autoFillMultiSKUFloorLoadedContainer')
  machine.transition('ALL_QUANTITIES_ADDED')
}

export const checkIfConfigChanged = () => {
  const isWroCreated = store.getters[ModuleName + '/isWroCreated']
  if (isWroCreated) {
    const draft = store.getters[ModuleName + '/draft']
    const editWro = store.getters[ModuleName + '/editWro']
    var draftConfigModelToCompare = []
    var editWroConfigModelToCompare = []
    if (store.getters[ModuleName + '/draft'].skuType.id === 2) {
      draftConfigModelToCompare = mapMultiSkuConfigBasedOnSkuConfig(draft.multiSKUShippingConfigurations.flatMap(x => x.skuConfigurations))
      editWroConfigModelToCompare = mapMultiSkuConfigBasedOnSkuConfig(editWro.multiSKUShippingConfigurations.flatMap(x => x.skuConfigurations))
    } else {
      draftConfigModelToCompare = mapSingleSkuConfigBasedOnSkuConfig(draft.shippingConfigurations)
      editWroConfigModelToCompare = mapSingleSkuConfigBasedOnSkuConfig(editWro.shippingConfigurations)
    }
    var isConfigsNotChanged = _isEqual(draftConfigModelToCompare, editWroConfigModelToCompare)
    if (!isConfigsNotChanged) store.getters[ModuleName + '/draft'].hasBoxConfigsChanged = true
  }
}

const mapMultiSkuConfigBasedOnSkuConfig = (skuConfig) => {
  var configModelToCompare = []
  var boxNumb = -1
  skuConfig.forEach(x => {
    if (x.id === 0) boxNumb++
    configModelToCompare.push({
      boxNumber: boxNumb,
      qty: x.quantityPerBox,
      noOfBox: x.numberOfBoxes,
      product: {
        id: x.product.id,
        lotNumber: x.product.lotInformation.lotNumber,
        lotDate: x.product.lotInformation.expirationDate
      }
    })
  })
  return configModelToCompare
}

const mapSingleSkuConfigBasedOnSkuConfig = (skuConfig) => {
  var singleSkuConfig = []
  skuConfig.forEach(x => {
    var id = x.productId
    var lotNumber = x.lotNumber
    var expDate = x.expirationDate
    x.boxConfigurations.forEach(y => {
      var qty = y.quantityPerBox
      var numberOfBoxes = y.numberOfBoxes
      singleSkuConfig.push({
        id,
        lotNumber,
        expDate,
        qty,
        numberOfBoxes
      })
    })
  })
  return singleSkuConfig
}
